import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex flex-grow" }
const _hoisted_3 = { class: "flex flex-grow md:flex-grow-0" }
const _hoisted_4 = { class: "flex flex-grow-0 md:flex-grow" }
const _hoisted_5 = { class: "mt-1 mr-3 hidden md:inline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, {
    class: "bg-white",
    style: {"height":"100vh"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, {
        class: "shadow-md",
        style: {"padding":"10px 6px","height":"52px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  class: "w-24 md:w-40",
                  type: "primary",
                  style: _normalizeStyle({ backgroundColor: _ctx.defaultActive !== _ctx.ROUTES.ALARM ? '#c2dbf0' : '' }),
                  text: _ctx.defaultActive !== _ctx.ROUTES.ALARM,
                  bg: _ctx.defaultActive !== _ctx.ROUTES.ALARM,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.ALARM)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createElementVNode("span", { class: "material-symbols-outlined text-xl" }, "home", -1)
                      ])),
                      _: 1
                    }),
                    _cache[14] || (_cache[14] = _createElementVNode("span", null, [
                      _createElementVNode("span", { class: "md:hidden" }, "Limitock"),
                      _createElementVNode("span", { class: "hidden md:block" }, "Limitock期限管理")
                    ], -1))
                  ]),
                  _: 1
                }, 8, ["style", "text", "bg"]),
                _createVNode(_component_el_button, {
                  class: "w-8 md:w-28",
                  type: "info",
                  color: _ctx.defaultActive === _ctx.ROUTES.INVENTORY2 ? '#000000' : '',
                  style: _normalizeStyle({ backgroundColor: _ctx.defaultActive !== _ctx.ROUTES.INVENTORY2 ? '#b7b7b7' : '' }),
                  text: _ctx.defaultActive !== _ctx.ROUTES.INVENTORY2,
                  bg: _ctx.defaultActive !== _ctx.ROUTES.INVENTORY2,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.INVENTORY2)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createElementVNode("span", { class: "material-symbols-outlined text-xl" }, "quick_reference_all", -1)
                      ])),
                      _: 1
                    }),
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "hidden md:block" }, "在庫一覧", -1))
                  ]),
                  _: 1
                }, 8, ["color", "style", "text", "bg"]),
                (_ctx.canShowPaymentMenu)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "w-8 md:w-28",
                      type: "info",
                      color: _ctx.defaultActive === _ctx.ROUTES.PAYMENT ? '#000000' : '',
                      style: _normalizeStyle({ backgroundColor: _ctx.defaultActive !== _ctx.ROUTES.PAYMENT ? '#b7b7b7' : '' }),
                      text: _ctx.defaultActive !== _ctx.ROUTES.PAYMENT,
                      bg: _ctx.defaultActive !== _ctx.ROUTES.PAYMENT,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.PAYMENT)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createElementVNode("span", { class: "material-symbols-outlined text-xl" }, "trolley", -1)
                          ])),
                          _: 1
                        }),
                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "hidden md:block" }, "払い出し", -1))
                      ]),
                      _: 1
                    }, 8, ["color", "style", "text", "bg"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  class: "w-8 md:w-28",
                  type: "info",
                  color: _ctx.defaultActive === _ctx.ROUTES.CONSTANT_MANAGE2 ? '#000000' : '',
                  style: _normalizeStyle({ backgroundColor: _ctx.defaultActive !== _ctx.ROUTES.CONSTANT_MANAGE2 ? '#b7b7b7' : '' }),
                  text: _ctx.defaultActive !== _ctx.ROUTES.CONSTANT_MANAGE2,
                  bg: _ctx.defaultActive !== _ctx.ROUTES.CONSTANT_MANAGE2,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.CONSTANT_MANAGE2)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createElementVNode("span", { class: "material-symbols-outlined text-xl" }, "checklist", -1)
                      ])),
                      _: 1
                    }),
                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "hidden md:block" }, "定数管理", -1))
                  ]),
                  _: 1
                }, 8, ["color", "style", "text", "bg"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || _ctx.loginUserRole === _ctx.ROLES.ADMIN)
                  ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 0,
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.ORGANIZATION)))
                                }, {
                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                    _createTextVNode("組織マスタ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 1,
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.DEPARTMENT)))
                                }, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createTextVNode("部門マスタ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || _ctx.loginUserRole === _ctx.ROLES.ADMIN)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 2,
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.USER)))
                                }, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createTextVNode("ユーザーマスタ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || _ctx.loginUserRole === _ctx.ROLES.ADMIN)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 3,
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.CATEGORY)))
                                }, {
                                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                                    _createTextVNode("カテゴリマスタ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || _ctx.loginUserRole === _ctx.ROLES.ADMIN)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 4,
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.MATERIAL)))
                                }, {
                                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                                    _createTextVNode("アイテムマスタ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 5,
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.JANCODE)))
                                }, {
                                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                                    _createTextVNode("JANコードマスタ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || _ctx.loginUserRole === _ctx.ROLES.ADMIN)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 6,
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.LOG)))
                                }, {
                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                    _createTextVNode("履歴確認")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 7,
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.SETTINGS)))
                                }, {
                                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                                    _createTextVNode("環境設定")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "ml-3 w-8 md:w-36",
                          type: "info",
                          color: _ctx.settingPaths.includes(_ctx.defaultActive) ? '#000000' : '',
                          style: _normalizeStyle({ backgroundColor: !_ctx.settingPaths.includes(_ctx.defaultActive) ? '#b7b7b7' : '' }),
                          text: !_ctx.settingPaths.includes(_ctx.defaultActive),
                          bg: !_ctx.settingPaths.includes(_ctx.defaultActive)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                _createElementVNode("span", { class: "material-symbols-outlined text-xl" }, "settings", -1)
                              ])),
                              _: 1
                            }),
                            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "hidden md:block" }, "システム設定", -1))
                          ]),
                          _: 1
                        }, 8, ["color", "style", "text", "bg"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  class: "mx-3 w-8 md:w-28",
                  type: "info",
                  color: _ctx.defaultActive === _ctx.ROUTES.PERSONAL_SETTINGS ? '#000000' : '',
                  style: _normalizeStyle({ backgroundColor: _ctx.defaultActive !== _ctx.ROUTES.PERSONAL_SETTINGS ? '#b7b7b7' : '' }),
                  text: _ctx.defaultActive !== _ctx.ROUTES.PERSONAL_SETTINGS,
                  bg: _ctx.defaultActive !== _ctx.ROUTES.PERSONAL_SETTINGS,
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.PERSONAL_SETTINGS)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createElementVNode("span", { class: "material-symbols-outlined text-xl" }, "person", -1)
                      ])),
                      _: 1
                    }),
                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "hidden md:block" }, "個人設定", -1))
                  ]),
                  _: 1
                }, 8, ["color", "style", "text", "bg"])
              ])
            ]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getUserName()), 1),
            _createVNode(_component_el_button, {
              class: "w-8",
              type: "info",
              style: {"background-color":"#b7b7b7"},
              text: "",
              bg: "",
              onClick: _ctx.logout
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createElementVNode("span", { class: "material-symbols-outlined text-xl" }, "logout", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, { style: {"padding":"0px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}